import React from "react";
const Home = () => {
  return <h4>Home</h4>;
};
export default Home;
